import type { Messages } from "@/locale";

export function titleForPath(pathname: string, m: Messages): string {
  if (pathname === "/") return m.titles.home;

  const exact: Record<string, string> = {
    "/login": m.titles.login,
    "/register": m.titles.register,
    "/privacy": m.titles.privacy,
    "/terms": m.titles.terms,
    "/app": m.titles.overview,
    "/app/environment": m.titles.environment,
    "/design/environment-save": m.titles.environmentSave,
    "/app/machines": m.titles.machines,
    "/app/projects": m.titles.projects,
    "/app/tasks": m.titles.tasks,
    "/app/integrations": m.titles.connections,
    "/app/account": m.titles.account,
    "/operator": m.titles.operator,
    "/admin": m.titles.admin,
    "/operator/workspace-requests": m.titles.operatorWorkspaceRequests,
  };

  if (exact[pathname]) return exact[pathname];
  if (/^\/app\/projects\/[^/]+\/workspace-requests/.test(pathname)) {
    return m.titles.workspaceRequests;
  }
  if (pathname.startsWith("/app/projects/")) return m.titles.project;
  if (pathname.startsWith("/app/tasks/")) return m.titles.task;
  if (pathname.startsWith("/app/leases/")) return m.titles.lease;
  if (pathname.startsWith("/app/operations/")) return m.titles.operation;
  return m.titles.notFound;
}
